import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  ariaLabelFacebook: {
    id: `seo_title_facebook`,
  },

  ariaLabelInstagram: {
    id: `seo_title_instagram`,
  },

  ariaLabelTwitter: {
    id: `seo_title_twitter`,
  },

  ariaLabelYouTube: {
    id: `seo_title_youtube`,
  },
});
